import { transport } from "@opengov/app-core/transport";

export interface CommentDeletedActivityData {
    comment: {
        id: string;
        text: string;
        topicId: string;
        topicType: string;
        entityId: string;
        removalReason?: string;
        removedBy?: string;
    };
    userUuid: string;
    entityId: number;
}

export const sendCommentRemovedActivity = (data: CommentDeletedActivityData): void => {
    const { comment, userUuid, entityId } = data;

    // Form the item URN based on context
    const itemUrn = `urn:opengov:stories:comment/${comment.id}`;
    const message = {
        id: crypto.randomUUID(),
        source: "urn:opengov:service/stories-service",
        specversion: "1.0",
        type: "com.opengov.user-activity.v1.delete",
        datacontenttype: "application/json",
        time: new Date().toISOString(),
        subject: userUuid,
        data: {
            userActivity: {
                itemUrn: itemUrn,
                userId: userUuid,
                entityId: entityId,
                activityTime: new Date().toISOString(),
                itemUrl: window.location.href,
                itemName: `Story/${comment.topicId}/Comment/${comment.id}`,
                itemType: 'StoryComment',
                itemId: comment.id,
                storyComment: {
                    id: comment.id,
                    text: comment.text,
                    topicId: comment.topicId,
                    topicType: comment.topicType,
                    entityId: comment.entityId,
                    removalReason: comment.removalReason,
                    removedBy: comment.removedBy,
                }
            }
        }
    };
    void transport
        .url('/user_activity_service/stories')
        .json(message)
        .post();
};
